import React from "react"
import InfoIcon from "../../icon/icons/InfoIcon"
import Tooltip from "../Tooltip"

type Ownprops = {
    tooltipMessage?: string
}

const InfoIconTooltip = (props: Ownprops) => {
    return (
        <Tooltip
            tooltipId="info_icon_tooltip"
            message={<p className="m-0">{props.tooltipMessage}</p>}>
            <div>
                <InfoIcon />
            </div>
        </Tooltip>
    )
}

export default InfoIconTooltip


// WEBPACK FOOTER //
// ./src/common/tooltip/tooltips/InfoIconTooltip.tsx